<template>
  <TolgeeProvider>
    <NaiveProvider>
      <!-- has a layout -->
      <Component :is="layout" v-if="layout">
        <RouterView />
      </Component>

      <!-- no layout, e.g. the respondent facing runtime -->
      <RouterView v-else />
    </NaiveProvider>
  </TolgeeProvider>
</template>

<script setup lang="ts">
import DefaultLayout from '@/views/_layouts/default.layout.vue'
import NaiveProvider from '@/components/common/NaiveProvider.vue'
import { type Component, computed } from 'vue'
import { RouterView, useRoute } from 'vue-router'
import { TolgeeProvider } from '@tolgee/vue'

defineOptions({
  name: 'SignalCollectionApp',
})

// keys here must match with the meta.layout in the router file
const layouts: Record<TAppLayout, Component> = {
  DefaultLayout,
}
const route = useRoute()
const layout = computed(() => (route.meta.layout ? layouts[route.meta.layout] : undefined))
</script>
